export default "__VITE_ASSET__DkLoJefF__"